import React from 'react';
export const replaceWithTags = (text, key1, tag1, key2, tag2) => {
    text = text.replaceAll(key1, "#$1#");
    if (key2) {
        text = text.replaceAll(key2, "#$2");
    }
    const splitText = text.split("#");
    let assembled = [];
    if (splitText.length == 1)
        return [<>{text}</>];
    splitText.forEach(piece => {
        if (piece.indexOf("$1") > -1) {
            assembled.push(tag1);
        }
        else if (piece.indexOf("$2") > -1) {
            assembled.push(tag2);
        }
        else {
            assembled.push(<>{piece}</>);
        }
    });
    return assembled;
};
